import React from 'react';
import HeroSection from '../components/HeroSection';
import aboutImage from '../images/onas.jpg';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

const clientReviews = [
  {
    name: 'Anna K.',
    text: 'Pełen profesjonalizm, indywidualne podejście i miła atmosfera. Polecam z całego serca!',
    rating: 5,
  },
  {
    name: 'Tomasz L.',
    text: 'Pomoc w doborze ubezpieczenia była bezcenna. Wszystko sprawnie i jasno wyjaśnione.',
    rating: 5,
  },
  {
    name: 'Małgorzata P.',
    text: 'Rzetelna obsługa, świetny kontakt i realne wsparcie. Czuję się naprawdę zaopiekowana.',
    rating: 5,
  },
];

const renderStars = (count) => {
  return (
    <div style={{ display: 'flex', gap: '2px', marginBottom: '0.5rem' }}>
      {[...Array(5)].map((_, i) =>
        i < count ? (
          <StarIcon key={i} style={{ color: '#FFD700', fontSize: '20px' }} />
        ) : (
          <StarBorderIcon key={i} style={{ color: '#ddd', fontSize: '20px' }} />
        )
      )}
    </div>
  );
};

const Onas = () => {
  return (
    <>
      <HeroSection image={aboutImage} text="Poznaj naszą agencję ubezpieczeniową" />

      <section
        style={{
          maxWidth: '1100px',
          margin: '3rem auto',
          padding: '0 1rem',
          display: 'flex',
          flexWrap: 'wrap',
          gap: '1.5rem',
          boxSizing: 'border-box',
        }}
      >
        {/* LEWA STRONA */}
        <div style={{ flex: '1 1 320px', minWidth: '0' }}>
          <p>
            Zapraszam do współpracy w zakresie kompleksowej obsługi ubezpieczeniowej. Od wielu lat
            z powodzeniem działam w branży ubezpieczeń, oferując rzetelne doradztwo oraz
            indywidualnie dopasowane rozwiązania zarówno dla klientów indywidualnych, jak i firm.
          </p>
          <p>
            Wieloletnie doświadczenie pozwala mi skutecznie identyfikować potrzeby Klientów oraz
            proponować najlepsze dostępne na rynku produkty ubezpieczeniowe – w zakresie ubezpieczeń
            majątkowych, komunikacyjnych, na życie, zdrowotnych, dla branży medycznej, także dla
            firm i rolników.
          </p>
          <p>
            Jeżeli poszukują Państwo solidnego partnera, który stawia na jakość, uczciwość i
            długofalowe relacje – serdecznie zapraszam do kontaktu.
          </p>
        </div>

        {/* PRAWA STRONA */}
        <div style={{ flex: '1 1 320px', minWidth: '0' }}>
          <h3 style={{ marginBottom: '1rem' }}>Opinie naszych klientów</h3>
          {clientReviews.map((review, index) => (
            <div
              key={index}
              style={{
                background: '#ffffff',
                padding: '1.2rem',
                borderRadius: '16px',
                marginBottom: '1.2rem',
                boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
                borderLeft: '4px solid #1976d2',
              }}
            >
              {renderStars(review.rating)}
              <p style={{ fontStyle: 'italic', marginBottom: '0.8rem', lineHeight: '1.5' }}>
                “{review.text}”
              </p>
              <p style={{ fontWeight: 500, textAlign: 'right', margin: 0 }}>– {review.name}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Onas;
